import FormTrab from './FormTrab/FormTrab'
export const FormTrabPage = FormTrab
